import styled from 'styled-components'
import { ColoredIcon } from 'component/ColoredIcon'
import themeAsseticonCloseSvg from '@theme/icon/close.svg'

export const IconClose = styled(ColoredIcon).attrs({
  src: themeAsseticonCloseSvg,
})`
  height: 0.6rem;
  width: 0.6rem;
  position: absolute;
  top: 0.275rem;
  right: 0.4rem;
`

export const Wrapper = styled.div`
  position: absolute;
  display: grid;
  grid-template-rows: auto 1fr;
  background: var(--component-modal-game-service-background);
  bottom: 0;
  top: 0;
  border-radius: 0.25rem 0.25rem 0 0;
  padding: 0.6rem 0.2rem max(0.6rem, env(safe-area-inset-bottom)) 0.2rem;
  color: var(--component-modal-game-service-color);
  width: 100%;
  font-size: 0.35rem;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  padding-bottom: 0.4rem;
`

export const Avatar = styled.img`
  width: 1.4rem;
  height: 1.4rem;
`

export const Title = styled.div`
  color: var(--component-modal-title-color);
  font-size: 0.4rem;
  font-weight: 700;
`

export const Subtitle = styled.div`
  color: var(--component-modal-title-color);
  font-size: 0.35rem;
`

export const HintList = styled.div`
  padding-top: 0.1rem;
  color: var(--component-modal-title-color);
  font-size: 0.35rem;
  line-height: 1;
`

export const HintTitle = styled.div`
  color: var(--component-modal-game-service-color);
  font-size: 0.35rem;
  font-weight: 700;
  line-height: 1;
`
